/* 陸遜傳・第 1 章：丹楊山谷（約 217 年）
 * 一條東西向的山谷，谷底是巡山的路，東邊盡頭是費棧的山寨。谷的南北兩側是高地，各有一條山徑通到三處高點（插牙幢、布鼓角的地方）；
 * 高地和谷底之間是岩壁與密林，谷底看不到高地。西邊谷口是陸遜的營，營的南邊是一座村（補戶）。 */
export const CAMP = [900, 2300], ZHAI = [7400, 2300], VILLAGE = [1500, 3950], MOUTH = [1900, 2300];
export const SPOTS = [[3000, 1250], [4500, 1200], [5900, 1250], [3000, 3350], [4500, 3400], [5900, 3350]]; // 高點：北三、南三
export default {
  id: 'luxun_shanyue', name: '丹楊山谷', W: 8400, H: 4600, seed: 217,
  bases: [CAMP, ZHAI],
  roads: [
    { pts: [CAMP, MOUTH, [3600, 2320], [5200, 2280], [6600, 2300], ZHAI], w: 150 },
    { pts: [MOUTH, [2300, 1500], SPOTS[0], SPOTS[1], SPOTS[2], [6700, 1600], ZHAI], w: 110 },
    { pts: [MOUTH, [2300, 3100], SPOTS[3], SPOTS[4], SPOTS[5], [6700, 3000], ZHAI], w: 110 },
    { pts: [CAMP, [1100, 3200], VILLAGE], w: 110 },
  ],
  rocks: [[3700, 1780, 760, 150], [5300, 1760, 560, 140], [3700, 2830, 760, 150], [5300, 2850, 560, 140]],
  woods: 0.75,
  sight: 0.6,
  clearings: [[CAMP[0], CAMP[1], 560], [ZHAI[0], ZHAI[1], 600], ...SPOTS.map(([x, y]) => [x, y, 240]), [MOUTH[0], MOUTH[1], 260]],
  grass: [[5300, 1070, 170, 80], [5300, 3530, 170, 80]], // 山徑旁的草叢：躲著等哨轉頭
  villages: [{ x: VILLAGE[0], y: VILLAGE[1], n: 6, r: 360 }],
  fields: [[2300, 4100, 420, 200]],
  tents: [{ x: CAMP[0], y: CAMP[1], n: 6, r: 380, chief: true, col: '#b8433a', flag: '陸' }, { x: ZHAI[0], y: ZHAI[1], n: 9, r: 460, chief: true, col: '#5a6a40', flag: '費' }],
};
